import axios from '../axios'

// フィードバック送信。payload = { rating, message, module_id?, subject? }
const postFeedbackApi = async (payload) => {
  return await axios.post('api/lms/feedback', payload)
}

export default postFeedbackApi
